import React from "react";
import HeroSection from "./HeroSection";
import ContactSection from "./ContactSection";
import MakeDonation from "./MakeDonation";

const Contact = () => {
  return (
    <div>
      <HeroSection/>
      <ContactSection/>
      <MakeDonation/>
    </div>
  );
};

export default Contact;
